import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Mail } from "lucide-react";
import { eventInfo } from "../lib/api";

const faqs = [
  { q: "When do I have to pay for the room?", a: "Right away. To lock in your room, send the 3-night total via Venmo, PayPal, or Revolut when you fill out the claim form. Your room isn't officially held until payment hits, too many moving parts otherwise. Flights and everything else you book and pay for yourself." },
  { q: "Can I bring my kids?", a: "Villa Taina and all events are no kids. If you're bringing them, check the Other Hotels page. Several are kid-friendly and close by." },
  { q: "I'm coming alone, will I know people?", a: "Probably yes, and if not — everyone here is friendly and some of my best friends don't know each other yet. You'll be fine by the second rum punch." },
  { q: "What if I can't get a Villa Taina room?", a: "Check Other Hotels. A bunch are within a 5-10 minute walk or drive. You'll still be at every meal and every party." },
  { q: "Is the resort all-inclusive?", a: "No. Villa Taina is room-only, but breakfast is included with every room. Most dinners are on me (welcome dinner, Saturday party, and a few others). Lunches are on you — Cabarete has tons of great, affordable spots." },
  { q: "Do I need to rent a car?", a: "Not necessarily. Ubers and taxis are readily available in the Dominican Republic, and most of the main weekend activities will be centered around Cabarete/Villa Taina. The town is somewhat spread out, so if you're planning to extend your stay or explore more of the area, renting a car, scooter, or four-wheeler could be a fun option." },
  { q: "What's the dress code for the main party?", a: "Saturday night — one nice outfit. Something you'd wear to a cool rooftop. Not black tie. No need to pack heels that sink in the sand." },
  { q: "Is the water safe to drink?", a: "Stick to bottled or filtered water. Villa Taina provides it. Ice at reputable restaurants is fine." },
  { q: "Do I need travel insurance?", a: "Not required but recommended, especially for international travel. Look at Allianz, World Nomads, or your credit card's included coverage." },
  { q: "What if my flight gets delayed?", a: "Text me and the group. We'll save you food and you'll slide right in. No FOMO." },
  { q: "Can I extend my trip before or after?", a: "Absolutely. Villa Taina can probably accommodate — just tell them directly when you book. Plenty to do on the north coast for a few extra days." },
  { q: "Who do I contact with questions?", a: `Me, directly. Text me or email ${eventInfo.contactEmail}.` },
];

export default function FAQ() {
  return (
    <div className="bg-cream">
      <section className="pt-20 pb-10 md:pt-28 md:pb-14" data-testid="faq-hero">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-terracotta font-medium mb-4">Answers</p>
          <h1 className="font-display text-6xl md:text-8xl font-black text-ink leading-[0.9]">
            Real <span className="italic text-sage-dark">questions.</span>
          </h1>
          <p className="text-lg text-muted_ink mt-5 max-w-2xl">
            If it's not answered here, it's definitely answerable. Just ask.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} className="bg-sand border border-shell rounded-lg px-5">
                <AccordionTrigger className="text-left font-display text-lg md:text-xl font-bold text-ink hover:no-underline" data-testid={`faq-q-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted_ink text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 p-8 bg-terracotta text-cream rounded-lg flex flex-col sm:flex-row items-start sm:items-center gap-5" data-testid="faq-contact">
            <Mail className="w-8 h-8 flex-shrink-0 text-gold" />
            <div className="flex-1">
              <p className="font-display text-2xl font-black">Still have questions?</p>
              <p className="text-cream/90 text-sm mt-1">Email me at {eventInfo.contactEmail} or text me if you have my number.</p>
            </div>
            <a href={`mailto:${eventInfo.contactEmail}`} className="bg-cream text-terracotta rounded-full px-5 py-2.5 font-medium hover:bg-gold hover:text-ink transition-colors" data-testid="faq-email-btn">
              Email me
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
